export const BUSY = 'BUSY';
export const EMPTY = 'EMPTY';
export const ERROR = 'ERROR';
export const READY = 'READY';
